import React from 'react'
import { Filter } from '@/network/graphql.g'
import FiltersProvider from '@/providers/filterProvider/filtersProvider'

export type WithFilterProviderProps = {
  filter: Filter[]
} & Rest

export const withFilterProvider = (
  WrappedComponent: React.ComponentType
): ((props: WithFilterProviderProps) => JSX.Element) => {
  const ComponentWithFilterProvider = (props) => {
    return (
      <FiltersProvider filter={props.filter}>
        <WrappedComponent key={WrappedComponent.displayName} {...props} />
      </FiltersProvider>
    )
  }
  ComponentWithFilterProvider.displayName = `withFilterProvider(${WrappedComponent.displayName})`

  return ComponentWithFilterProvider
}
